export enum CustomEvents {
  USER_AUTHORIZED_SUCCESS = 'event_user_authorized_success',
  UPGRADE_FROM_TRIAL_PAYMENT_SUCCESS = 'event_upgrade_from_trial_payment_success',
  LOGIN_POPUP_CLOSE = 'event_login_popup_close',
  REQUEST_DATA_LAYER_UPDATE_FROM_BACKEND = 'request_datalayer_update_from_backend',
  // START ES39123
  // Host -> app: the Auto-upgrade consent was saved in the Welcome popup.
  AGREE_AUTO_UPGRADE_ES39123 = 'event_agree_autoupgrade_es39123',
  // Host -> app: the Payment Failed popup (or the checkout it opened) was closed without paying.
  AUTO_UPGRADE_DISMISSED_ES39123 = 'event_auto_upgrade_dismissed_es39123',
  // END ES39123
  // Host -> app
  THANKYOU_POPUP_CLOSE = 'event_thankyou_popup_close',
  // App -> host
  APP_INBOX_INIT = 'app_inbox_init',
}
